import React, { useEffect, useState, useCallback } from 'react';
import Pagination from '@mui/material/Pagination';
import MapComponent from '../MapComponent';
import RuleAlert from '../RuleAlert';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import moment from 'moment';

function Table({
  getTimeStreamData,
  showMap,
  height,
  deviceType,
  handleDeviceType,
  mapView,
  setTempType,
  tempType,
  lastReportedAt,
  setShowInventory,
}) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = JSON.parse(sessionStorage.user)?.organization?.id;
  const [{ isLoading, isError, data }, getData] = useApi();
  const [alert, setAlerts] = useState(false);
  const [stats, setStats] = useState([]);
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const formModel = {
    asset_type: '',
    device_type: '',
    project_name: '',
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const [downloadLoader, setDownloadLoader] = useState({ id: '', flag: false });
  const [showFloorMap, setShowFloorMap] = useState(false);
  // const [selectedType, setSelectedType] = useState({ type: '' });
  const [state, projectData] = useApi();
  const [alertDevice, setAlertDevice] = useState('');
  const [view, setView] = useState('listView');
  const [sensorReport, getSensorReport] = useApi();
  const [deviceIDCSV, setDeviceIdCSV] = useState('');

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleDeviceTypeChange = useCallback((e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value === 'BLE Tag' ? 'BLE_TAG' : e.target.value === 'Cellular Tag' ? 'CATM1_TAG' : '',
    })
  );
  const [project, setProject] = useState([]);
  const day = 1000 * 60 * 60 * 24;
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const getMiddleAlign = (idx) => {
    if (height) {
      const element = document.getElementById(idx);
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo(0, middle);
    } else {
      return document.getElementById(idx).scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${page}&scale=${tempType}`, 'GET');
    projectData(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (!searchFlag) {
      setCoordinates([]);
      if (!formData.device_type && !formData.asset_type && !formData.project_name) {
        user &&
          getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${page}&scale=${tempType}`, 'GET');
      } else {
        user &&
          getData(
            `/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&assetType=${formData.asset_type}&deviceType=${formData.device_type}&project=${formData.project_name}&&page=${page}&scale=${tempType}`,
            'GET'
          );
      }
    }
  }, [page]);

  useEffect(() => {
    setCoordinates([]);
    if (page === 1) {
      user &&
        getData(
          `/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&assetType=${formData.asset_type}&deviceType=${formData.device_type}&project=${formData.project_name}&&page=${page}&scale=${tempType}`,
          'GET'
        );
    } else setPage(1);
  }, [formData.asset_type, formData.project_name, formData.device_type]);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProject(state.data.projects);
    }
  }, [state.isLoading, state.isError, state.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      const coordinatesArray = [];
      // let x = data.assets || x.recentData
      if ((data.assets || data.recentData) && (data.assets || data.recentData).length > 0) {
        (data.assets || data.recentData).map((item, idx) => {
          const ts = getTime(item?.recentData?.ts);
          const coord = {
            lat: parseFloat(item?.recentData?.lat),
            lng: parseFloat(item?.recentData?.lng),
          };
          coordinatesArray.push(coord);
          item.latestTimeStamp = ts;
          return item;
        });
        const x = (data.assets || data.recentData).sort((a, b) => (a.latestTimeStamp < b.latestTimeStamp ? 1 : -1));
        setStats(x);
        if (page === 1) {
          const total = Math.ceil(data.count / itemsPerPage);
          setpageCount(total);
        }
      } else {
        setStats([]);
        setpageCount(0);
      }
      setCoordinates(() => coordinatesArray);
    }
    if (isError) {
      setStats([]);
      setpageCount(0);
      // setmaxPageNumberLimit(5);
      // setminPageNumberLimit(0);
    }
  }, [isLoading, isError, data]);

  // useEffect(() => {
  //   if (stats.length <= 0) {
  //     return;
  //   }
  //   // if (formData.asset_type === '' && formData.device_type === '' && formData.project_name === '') {
  //   setFilteredData(stats);
  //   // }
  //   // let z = stats;

  //   // if (formData.project_name) {
  //   //   z = z.filter((x) => x?.project?.projectName === formData.project_name);
  //   // }

  //   // if (formData.device_type) {
  //   //   z = z.filter((x) => x?.device?.deviceType === formData.device_type);
  //   // }

  //   // if (formData.asset_type) {
  //   //   z = z.filter((x) => x?.trackedUnit?.tuType === formData.asset_type);
  //   // }

  //   // if (z.length > 0) setFilteredData(z);
  //   // else setFilteredData([]);
  // }, [stats]);

  const getDeviceId = (id) => {
    getTimeStreamData(id);
  };

  const getTime = (ts) => {
    let _date;
    if (ts > 9999999999) {
      _date = Number(ts);
    } else {
      _date = Number(ts * 1000);
    }

    return _date;
  };

  const toggleAlert = () => {
    setAlerts((prev) => !prev);
    mapView(false);
  };

  const getTimeoffset = (ts) => {
    // const _ts = Number(ts);
    const _date = new Date(ts);
    // const timeZoneOffset = _date.getTimezoneOffset();
    // const _timestamp = _date.getTime();
    // if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
    //   return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    // }

    // if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
    //   return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    // }

    // if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
    //   return `${Math.round(
    //     ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
    //   )} minutes ago`;
    // }

    // return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;
    return moment(_date).fromNow();
    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  const downloadSensorDataReport = (_id, type) => {
    const id = _id;
    if (type == 'CATM1_TAG') {
      getSensorReport(`/device/${id}/data?start=0&end=4320`, 'GET');
    } else {
      getSensorReport(`/device/${id}/data?start=0&end=4320&dataType=BLE_LOG`, 'GET');
    }
  };

  useEffect(() => {
    if (sensorReport.data !== null) {
      if (sensorReport.data.response === null || sensorReport.data === null) {
        setDownloadLoader(false);
        return;
      }
      if (sensorReport.data && sensorReport.data.response && sensorReport.data.response.length === 0) {
        setDownloadLoader(false);
        return;
      }
      if (sensorReport.data && sensorReport.data.response && sensorReport.data.response.logs) {
        const keys1 = Object.keys(sensorReport.data.response.logs[0]);
        const keys2 = Object.keys(sensorReport.data.response.logs[1]);
        var keys = [...new Set([...keys1, ...keys2])];
        console.log('keys', keys);

        const comSep = [
          keys.join(','),
          sensorReport.data.response.logs.map((row) => keys.map((key) => row[key]).join(',')).join('\n'),
        ].join('\n');

        const csvBlob = new Blob([comSep]);
        const newDate = new Date(Date.now());
        const a = document.createElement('a');
        a.href = URL.createObjectURL(csvBlob);
        a.setAttribute('download', `${deviceIDCSV}-${newDate.toLocaleString()}.csv`);
        document.body.appendChild(a);
        a.click();
        setDownloadLoader(false);
        return;
      }
      if (sensorReport.data && sensorReport.data.response && sensorReport.data.response.length >= 1) {
        const rows = [];
        const headerRows = [];
        const headerRows2 = [];
        const sensorMeasureName = sensorReport.data.response;
        let tempArr = [];
        const arr = [
          'ts',
          'lat',
          'lng',
          'rssi',
          'vbat',
          'tm',
          'ax',
          'ay',
          'az',
          'prs',
          'li',
          'count',
          'timeOn',
          'rsrp',
          'rsrq',
          'failPub',
          'timeConn',
          'sinr',
          'evnts',
          'h',
        ];

        // Download from URL is url is present //
        // if(sensorReport.data.url) {
        //   // let content = 'data:text/csv;charset=utf-8,';
        //   // const encodedUri = encodeURI(content);
        //   const link = document.createElement('a');
        //   link.href = sensorReport.data.url;
        //   link.target = '_blank';
        //   link.download = sensorReport.data.url;
        //   link.click();
        //   setDownloadLoader(false);

        // }

        if (sensorMeasureName.length > 0) {
          arr.filter((x) => {
            // return sensorReport.data.response.tempArr.map((y) => {
            //   if (y[x] !== undefined) {
            headerRows.push(x);

            if (x === 'lat') headerRows2.push('Lat');
            if (x === 'lng') headerRows2.push('Lng');
            if (x === 'rssi') headerRows2.push('Rssi');
            if (x === 'ts') headerRows2.push('Timestamp');
            if (x === 'count') headerRows2.push('Count');
            if (x === 'timeOn') headerRows2.push('TimeOn');
            if (x === 'rsrp') headerRows2.push('Rsrp');
            if (x === 'rsrq') headerRows2.push('Rsrq');
            if (x === 'failPub') headerRows2.push('Failpub');
            if (x === 'failConn') headerRows2.push('Failconn');
            if (x === 'timeConn') headerRows2.push('Timeconn');
            if (x === 'id') headerRows2.push('Id');
            if (x === 'sinr') headerRows2.push('Sinr');
            if (x === 'evnts') headerRows2.push('Events');
            if (x === 'vbat') headerRows2.push('Vbat');
            if (x === 'tm') headerRows2.push('Temp');
            if (x === 'ax') headerRows2.push('Accl_x');
            if (x === 'ay') headerRows2.push('Accl_y');
            if (x === 'az') headerRows2.push('Accl_z');
            if (x === 'prs') headerRows2.push('Pressure');
            if (x === 'li') headerRows2.push('Light');
            if (x === 'h') headerRows2.push('Humidity');

            //   tempArr.push(y);
            // }
            // });
          });
        }
        tempArr = sensorReport.data.response;
        for (let i = 0; i < tempArr.length; i++) {
          const arr = [];
          for (let j = 0; j < headerRows.length; j++) {
            const index = j;
            const value = headerRows[j];
            const itemIndex = tempArr[i][value];
            // arr.push(tempArr[i].value[itemIndex]);
            arr.push(itemIndex);
            // arr.push(tempArr[j][headerRows[j]][i]);
            // console.log("itemIndex",tempArr[j][itemIndex][i]);

            // console.log("tempArr[j]",tempArr[j],tempArr[j].value[itemIndex], headerRows[j])
          }
          rows.push(arr);
        }
        let content = 'data:text/csv;charset=utf-8,';

        const newDate = new Date(Date.now());
        content += `${
          `Sensor Report For Device ID: ${deviceIDCSV} and Time:${newDate.toLocaleString()}` + '\n'
        }${headerRows2}\n${rows.join('\n')}`;
        /* create a hidden <a> DOM node and set its download attribute */
        const encodedUri = encodeURI(content);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `${deviceIDCSV}-${newDate.toLocaleString()}.csv`);
        document.body.appendChild(link);
        // /* download the data file named "Stock_Price_Report.csv" */
        link.click();
        setDownloadLoader(false);
      }
    }
    if (sensorReport.isError) {
      setDownloadLoader(false);
    }
  }, [sensorReport.data]);

  const searchData = () => {
    setSearchFlag(true);
    getData(`/organization/${orgId}/search?type=asset&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    setCoordinates([]);
    if (formData.q === '') {
      setSearchFlag(false);
      setPage(1);
      getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=1&scale=${tempType}`, 'GET');
    }
  }, [formData.q]);

  useEffect(() => {
    if (tempType) {
      getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${page}&scale=${tempType}`, 'GET');
    }
  }, [tempType]);

  const getTemp = (temp) => {
    let x = temp;
    if (x >= 256 && x <= 512) {
      x = x - 512.0;
    }
    return parseFloat(x).toFixed(1);
  };

  return (
    <>
      <div className="px-3">
        {!alert && (
          <>
            {' '}
            <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
              <div
                className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
                style={{ paddingTop: '4vh' }}
              >
                <span className="text-titleColor font-bold text-base mobile_icon">Dashboard</span>
                <div className="block lg:flex mt-1 lg:mt-0 gap-1">
                  <div className="flex mr-2">
                    <button
                      className={`${
                        tempType === 'C' ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
                      } px-4 h-7 text-xs focus:outline-none`}
                      onClick={() => {
                        setTempType('C');
                      }}
                    >
                      &#xb0;C
                    </button>
                    <button
                      className={`${
                        tempType === 'F' ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
                      } px-4 h-7 text-xs focus:outline-none`}
                      onClick={() => {
                        setTempType('F');
                      }}
                    >
                      &#xb0;F
                    </button>
                  </div>

                  <button
                    className={`mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1  rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 mobile_dash bg-btnBg text-white button_text `}
                    onClick={() => {
                      setShowInventory(true);
                    }}
                  >
                    Inventory
                  </button>

                  <button
                    className={`mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1  rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 mobile_dash bg-btnBg text-white button_text `}
                    onClick={() => {
                      setAlertDevice('');
                      mapView(true);
                      setAlerts(true);
                    }}
                  >
                    Alerts
                  </button>
                  <button
                    className={`mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1  rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 mobile_dash bg-btnBg text-white button_text `}
                    onClick={() => {
                      if (view === 'mapView') {
                        setView('listView');
                        mapView(false);
                      } else {
                        setView('mapView');
                        mapView(true);
                      }
                    }}
                  >
                    {view === 'listView' ? 'Map View' : 'List View'}
                  </button>
                  {/* <button
                  className={`mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 mobile_dash1 ${
                    view === 'listView' ? 'bg-gray-500' : 'bg-btnBg'
                  } text-white button_text`}
                  onClick={() => {
                    setView('mapView');
                    mapView(true);
                  }}
                >
                  Map View
                </button> */}

                  {!searchFlag && (
                    <Pagination
                      count={pageCount}
                      page={page}
                      onChange={handleChange}
                      variant="outlined"
                      shape="rounded"
                      size="small"
                      className="mobile_page"
                    />
                  )}
                  <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent sm:bg-white px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl mobile_search">
                    <input
                      type="text"
                      placeholder="Search"
                      autoComplete="off"
                      className="text-textBox bg-transparent focus:outline-none"
                      value={formData.q}
                      name="q"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                      onKeyDown={(e) => {
                        if (e.which === 13) searchData();
                      }}
                    />
                    <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="tbl" style={{ minWidth: '700px' }}>
              <div className={`bg-white ${view === 'mapView' ? 'w-full' : 'w-tableWidth'} m-auto mb-3`}>
                <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
                  <div className="px-8 py-1.5 flex w-full relative bg-primary text-white">
                    <div className="w-1/2 py-1 text-xs font-bold">
                      <div className="relative inline-flex">
                        <svg
                          className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none drop_resp"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 412 232"
                        >
                          <path
                            d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                            fill="#ffffff"
                            fillRule="nonzero"
                          />
                        </svg>
                        <select
                          className="border font-bold  overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md phone_font phone_drop"
                          style={{ borderColor: '#e6e6e6' }}
                          value={formData.asset_type}
                          name="asset_type"
                          onChange={handleInputChange}
                        >
                          <option value="">ASSET</option>
                          <option>BOX</option>
                          <option>PALLET</option>
                          <option>CONTAINER</option>
                          <option>UNIT</option>
                        </select>
                      </div>
                    </div>
                    <div className="w-1/2 py-1 text-xs font-bold">
                      <div className="relative inline-flex">
                        <svg
                          className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none drop_resp"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 412 232"
                        >
                          <path
                            d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                            fill="#ffffff"
                            fillRule="nonzero"
                          />
                        </svg>
                        <select
                          value={
                            formData.device_type === 'BLE_TAG'
                              ? 'BLE Tag'
                              : formData.device_type === 'CATM1_TAG'
                              ? 'Cellular Tag'
                              : ''
                          }
                          name="device_type"
                          className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md phone_font phone_drop"
                          style={{ borderColor: '#e6e6e6' }}
                          onChange={handleDeviceTypeChange}
                        >
                          <option value="">DEVICE</option>
                          <option>BLE Tag</option>
                          <option>Cellular Tag</option>
                        </select>
                      </div>
                    </div>

                    <div className="w-1/2 py-1 text-xs font-bold">
                      <div className="relative inline-flex">
                        <svg
                          className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none drop_resp"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 412 232"
                        >
                          <path
                            d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                            fill="#ffffff"
                            fillRule="nonzero"
                          />
                        </svg>
                        <select
                          value={formData.project_name}
                          name="project_name"
                          className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md phone_font phone_drop"
                          style={{ borderColor: '#e6e6e6' }}
                          onChange={handleInputChange}
                        >
                          <option value="">PROJECT</option>
                          {project.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.projectName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="w-1/2 py-2.5 text-xs text-left font-bold pl-2">SENSOR VALUES</div>
                    <div className="w-1/3 py-2.5 text-xs font-bold text-center">LAST REPORTED</div>
                    <div className="w-1/5 py-2.5 text-xs font-bold text-right">REPORT</div>
                  </div>
                </div>
                {view === 'mapView' ? (
                  <div className="h-100 w-full relative hideScroll">
                    <MapComponent
                      selectedPage="table"
                      coordinates={coordinates}
                      center={center}
                      selectedData={data && data.assets && data.assets}
                      // setShowFloorMap={setShowFloorMap}
                    />
                  </div>
                ) : (
                  <div>
                    {!isLoading ? (
                      <div className="hideScroll" style={{ overflowY: 'scroll', height: height ? '23vh' : '66vh' }}>
                        <div id="tblData" className="w-full">
                          {stats.length !== 0 &&
                            stats.map((item, idx) => {
                              // const modified = getTimeoffset(item?.lastReportedAt);
                              let assetTypeIcon = item?.trackedUnit?.tuType !== null ? item?.trackedUnit?.tuType : '';
                              if (item?.trackedUnit?.tuType === 'BOX')
                                assetTypeIcon = <img src="./assets/img/Box.svg" className="w-5 h-5" />;
                              if (item?.trackedUnit?.tuType === 'UNIT')
                                assetTypeIcon = <img src="./assets/img/Unit.svg" className="w-5 h-5" />;
                              if (item?.trackedUnit?.tuType === 'CONTAINER')
                                assetTypeIcon = <img src="./assets/img/Container.svg" className="w-5 h-5" />;
                              if (item?.trackedUnit?.tuType === 'PALLET')
                                assetTypeIcon = <img src="./assets/img/Pallet.svg" className="w-5 h-5" />;
                              let deviceTypeIcon = item?.device?.deviceType !== null ? item?.device?.deviceType : '';
                              if (item?.device?.deviceType === 'BLE_TAG')
                                deviceTypeIcon = <img src="./assets/img/Bluetooth.svg" className="w-5 h-5" />;
                              if (item?.device?.deviceType === 'CATM1_TAG')
                                deviceTypeIcon = <img src="./assets/img/Cellular.svg" className="w-5 h-5" />;
                              if (item?.device?.deviceType === 'BLE_GW')
                                deviceTypeIcon = <img src="./assets/img/Gateway.svg" className="w-5 h-5" />;
                              const orgInfo = {
                                ruleAlert: !!(item?.device?.RuleAlerts && item?.device?.RuleAlerts.length > 0),
                                type: assetTypeIcon,
                                code: item?.trackedUnit?.trackingId,
                                deviceId: item?.deviceId || item?.device?.id,
                                deviceType: deviceTypeIcon,
                                projectName: item?.project?.projectName,
                                // lastModified: modified,
                              };
                              return (
                                <div
                                  tabIndex={idx}
                                  id={idx}
                                  className="my-2.5 px-8 py-1 xl:py-2 flex
                        relative focus:bg-rowSelect hover:bg-rowSelect"
                                  style={{
                                    border: '0.5px solid #C0C0C0',
                                    boxSizing: 'border-box',
                                    borderRadius: '4px',
                                  }}
                                >
                                  {orgInfo.ruleAlert && (
                                    <img
                                      src="assets/img/alert.svg"
                                      className="absolute left-4 top-5 w-3 h-3 z-50"
                                      onClick={() => {
                                        setAlertDevice(item?.deviceId);
                                        setAlerts(true);
                                        mapView(true);
                                      }}
                                    />
                                  )}
                                  <div
                                    className="w-1/2 flex items-center text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={(e) => {
                                      getDeviceId(item?.deviceId);
                                      lastReportedAt(getTimeoffset(item?.lastReportedAt));
                                      showMap(true);
                                      deviceType(item?.trackedUnit?.trackingId, orgInfo.deviceId);
                                      setTimeout(() => {
                                        getMiddleAlign(idx);
                                      }, 500);
                                      handleDeviceType(item?.device?.deviceType);
                                    }}
                                  >
                                    {orgInfo.type}

                                    <p className="py-2 ml-2 text-xs md:no-underline md:hover:underline text-primary font-semibold phone_font cursor-pointer whitespace-nowrap overflow-hidden overflow-ellipsis hover:underline">
                                      {orgInfo.code}
                                    </p>
                                  </div>

                                  <div
                                    className="w-1/2 flex items-center text-role font-semibold text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={() => {
                                      showMap(false);
                                    }}
                                  >
                                    {orgInfo.deviceType}
                                    <span className="ml-2">{orgInfo.deviceId}</span>
                                  </div>

                                  <div
                                    className="w-1/2 flex text-role font-semibold items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={() => {
                                      showMap(false);
                                    }}
                                  >
                                    {orgInfo.projectName}
                                  </div>
                                  <div
                                    className="flex w-1/2 items-center text-role font-semibold text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={() => {
                                      showMap(false);
                                    }}
                                  >
                                    {item?.recentData?.tm ? (
                                      <div className="flex items-center">
                                        <img
                                          src="assets/img/temperature.png"
                                          className="w-2 mx-2 mt-1 phone_font"
                                          alt=""
                                        />
                                        {getTemp(item?.recentData?.tm)}
                                      </div>
                                    ) : null}
                                    {item?.recentData?.h ? (
                                      <div className="flex items-center">
                                        <img src="assets/img/humidity.png" className="w-3 mx-2 mt-1" alt="" />
                                        {parseFloat(item?.recentData?.h).toFixed(1)}
                                      </div>
                                    ) : null}
                                    {item?.recentData?.prs ? (
                                      <div className="flex items-center">
                                        <img src="assets/img/pressure.png" className="w-3 mx-2 mt-1" alt="" />
                                        {parseFloat(item?.recentData?.prs).toFixed(1)}
                                      </div>
                                    ) : null}
                                    {item?.recentData?.torValue ? (
                                      <div className="flex items-center">
                                        <img src="assets/img/probe-grey.svg" className="w-3 mx-2 mt-1" alt="" />
                                        {parseFloat(item?.recentData?.torValue) * 0.5}
                                      </div>
                                    ) : null}
                                  </div>
                                  <div
                                    className="w-1/3 flex text-role font-semibold items-center justify-center text-right overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={() => {
                                      showMap(false);
                                    }}
                                  >
                                    {getTimeoffset(item?.lastReportedAt)}
                                  </div>
                                  <div
                                    className="w-1/5 flex text-role font-semibold items-center cursor-pointer text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font"
                                    onClick={() => {
                                      setDeviceIdCSV(item?.deviceId);
                                      showMap(false);
                                      downloadSensorDataReport(item?.deviceId, item?.device?.deviceType);
                                      setDownloadLoader({ id: idx, flag: true });
                                    }}
                                  >
                                    <img src="assets/img/Report_Download.svg" className="h-4 ml-auto mr-3" alt="" />
                                    {downloadLoader.id === idx && (
                                      <img src="assets/img/loader.svg" className="w-9 mx-auto" alt="" />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    ) : (
                      <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
        {alert && <RuleAlert handleClose={toggleAlert} deviceId={alertDevice} />}
      </div>
    </>
  );
}

export default Table;
